import { DataFetchProvider } from '@betterment/js-runtime';
import { BrowserRouter as Router } from 'react-router-dom';

import Controller from '../components/LoginChallengeFlow/Controller';
import { InitialProps } from '../components/LoginChallengeFlow/data';
import { buildAppPath } from '../utils/path-helpers';

const LoginChallengeFlow: React.FC<InitialProps> = initialProps => {
  const baseName = buildAppPath('/better_mfa/login_challenge');

  return (
    <DataFetchProvider>
      <Router basename={baseName}>
        <Controller {...initialProps} />
      </Router>
    </DataFetchProvider>
  );
};

export default LoginChallengeFlow;
